import { useRoleBasedCountryFilter } from 'components/UniversalFilters/RBCountryFilter';
import { useMemo, useState } from 'react';

const useFarmerFilters = () => {
  const [country, setCountry] = useRoleBasedCountryFilter();
  const [groupName, setGroupName] = useState<string[] | null>(null);
  const [contractStatus, setContractStatus] = useState<string | null>(null);
  const [farmerStatus, setFarmerStatus] = useState<string | null>(null);
  const [searchedName, setSearchedName] = useState<string | null>(null);
  const [agronomist, setAgronomist] = useState<string[] | null>(null);

  const filterParams = useMemo(() => {
    const params: Record<string, string> = {};

    if (country?.trim()?.length > 0) params['country.equals'] = country;
    if (contractStatus && contractStatus?.trim()?.length > 0)
      params['contractStatus.equals'] = contractStatus;
    if (farmerStatus && farmerStatus?.trim()?.length > 0)
      params['status.equals'] = farmerStatus;
    if (searchedName && searchedName?.trim()?.length > 0)
      params['name.contains'] = searchedName;
    if (groupName && groupName?.length > 0)
      params['cubeId.in'] = groupName.join(',');
    if (agronomist && agronomist?.length > 0)
      params['fieldCoordinatorId.in'] = agronomist.join(',');

    return params;
  }, [agronomist, country, groupName, contractStatus, farmerStatus, searchedName]);

  return {
    agronomist,
    country,
    groupName,
    contractStatus,
    farmerStatus,
    searchedName,
    setAgronomist,
    setCountry,
    setGroupName,
    setContractStatus,
    setFarmerStatus,
    setSearchedName,
    filterParams,
  };
};

export default useFarmerFilters;
